import { Stack } from '@mui/material'
import SettingsSelectionList from './settings-selection-list/settings-selection-list.component'

const SettingsSelection = () => {
  return (
    <Stack sx={{ height: '100%' }}>
      <SettingsSelectionList />
    </Stack>
  )
}

export default SettingsSelection
